import type { SocialMediaLinkBlockProps } from './types';

export type { SocialMediaLinkBlockProps };

export function SocialMediaLinkBlock({ name, url, logo }: SocialMediaLinkBlockProps) {
  return (
    <div className="flex flex-col gap-4">
      <a href={url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
        {logo && (
          <img 
            src={logo} 
            alt={`${name} logo`} 
            className="w-6 h-6"
          />
        )}
        <span>{name}</span>
      </a>
    </div>
  );
}
